<div class="provider-options">
  <% if (desiredProviderSlots.length) { %>
    <div data-provider-option="desired" class="provider-option provider-option--desired<% if (selectedProviderOption == 'desired') { %> provider-option--selected <% } %>">
      <span class="icon"><img src="<%= desiredProvider.imageUrl %>"/></span>
      <span class="text"><%= desiredProvider.name %></span>
    </div>
  <% } %>
  <% if (poolProviders.length) { %>
    <div data-provider-option="pool" class="provider-option provider-option--pool<% if (selectedProviderOption == 'pool') { %> provider-option--selected<% } %>">
      <span class="icon">
        <% poolProviders.slice(0, 3).forEach(function(provider){ %>
          <img src="<%= provider.imageUrl %>"/>
        <% }) %>
      </span>
      <span class="text"><%= suggestionAlgorithmTitle %></span>

      <% if (metadata.sameTimeAvailable) { %>
        <span class="button-caption"><%= I18n.provider_selector.same_time_available %></span>
      <% } else if (metadata.earlierTimeAvailable) { %>
        <span class="button-caption"><%= I18n.provider_selector.earlier_time_available %></span>
      <% } else if (metadata.earliestTimeAvailable) { %>
        <span class="button-caption">
          <%= suggestionDateBias == 'earliest' ? I18n.provider_selector.earliest : I18n.provider_selector.best_match %> · <%= Sparkle.Utilities.appointmentDate(moment.parseZone(metadata.earliestTimeAvailable), AppointmentBooking.config.slot_show_year, 'MMM D', 'MMM D, YYYY') %></span>
      <% } %>
    <% } %>
  </div>
</div>
